"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
/**
 * Updates rawScore, scaledScore and successStatus fields
 * using (successCriteria + completionStatus +
 * allQuestionsGraded)
 */
function updateSuccessStatusFieldsForCheckpoint(user, content, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const lastSubmission = state.submissions[0];
    if (lastSubmission) {
        switch (lastSubmission.submissionStatus) {
            case entity_1.CheckpointSubmissionStatus.APPROVED:
                state.successStatus = entity_1.CheckpointSuccessStatus.PASS;
                break;
            case entity_1.CheckpointSubmissionStatus.REJECTED:
                state.successStatus = entity_1.CheckpointSuccessStatus.FAIL;
                break;
            default:
                state.successStatus = entity_1.CheckpointSuccessStatus.NA;
        }
    }
    else {
        state.successStatus = entity_1.CheckpointSuccessStatus.NA;
    }
}
exports.updateSuccessStatusFieldsForCheckpoint = updateSuccessStatusFieldsForCheckpoint;
//# sourceMappingURL=updateSuccessStatusFieldsForCheckpoint.js.map